'use client';

import { IHomeDictionary } from '@/dictionaries/pages/home/types';
import { getTranslation } from '@/lib/utils';
import { useState } from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import Slider from 'react-slick';
import { Locale } from '../../../../i18n.config';
import HomeVillasCarouselItem from './HomeVillasCarouselItem';
import './styles.css';

const settings = {
  dots: true,
  infinite: true,
  speed: 700,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  dotsClass: 'carousel-dots',
  // centerMode: true,
  // centerPadding: '13.104%',
  responsive: [
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
      },
    },
  ],
};

type Props = {
  dict: IHomeDictionary;
  catalogItems: Catalog[];
  lang: Locale;
  sicilySlug: string;
};

export default function HomeVillasCarousel({
  dict,
  catalogItems,
  lang,
  sicilySlug,
}: Props) {
  const [sliderRef, setSliderRef] = useState<Slider | null>(null);

  return (
    <div className="relative w-full desktop:h-full">
      <button
        id="home-carousel-previous-button"
        aria-label="Carousel previous button"
        className="rounded-full z-10 text-zinc-400 flex justify-center
        group items-center bg-white shadow-lg overflow-hidden absolute top-1/2 left-0  translate-y-[-50%] mt-[-50px] w-11 h-[44px]"
        type="button"
        onClick={sliderRef?.slickPrev}>
        <FiChevronLeft className="w-6 h-6 stroke-slate-600 opacity-30 group-hover:opacity-20 transition" />
      </button>

      <Slider
        ref={setSliderRef}
        className="p-0 desktop:px-8 [&>.slick-list]:overflow-visible"
        {...settings}>
        {catalogItems.map((item, index) => {
          const itemTranslation = getTranslation(item.translate, lang);
          const url =
            lang === 'en'
              ? `/${sicilySlug}/${itemTranslation.slug}`
              : `${lang}/${sicilySlug}/${itemTranslation.slug}`;

          return (
            <div className="px-2" key={index}>
              <HomeVillasCarouselItem
                sizes="(min-width: 1200px) 80vw, 1280px"
                info={{
                  body: itemTranslation.shortDescription || '',
                  title: itemTranslation.title,
                  buttonText: dict.villas.discoverVillas,
                  banner: item.image
                    ? `${item.image?.path}${item.image?.filename}`
                    : '',
                  url,
                  countItems: item.countItems,
                }}
              />
            </div>
          );
        })}
      </Slider>

      <button
        id="home-carousel-next-button"
        aria-label="Carousel next button"
        className="rounded-full z-10 text-zinc-400 flex justify-center
        group items-center bg-white shadow-lg overflow-hidden absolute top-1/2 right-0 translate-y-[-50%] mt-[-50px] w-11 h-[44px]"
        type="button"
        onClick={sliderRef?.slickNext}>
        <FiChevronRight className="w-6 h-6 stroke-slate-600 opacity-30 group-hover:opacity-20 transition" />
      </button>
    </div>
  );
}
